import React from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import { SendAndShareModal } from '../components/SendAndShare/SendAndShareModal';
import { NotFound } from 'app/pages/notFound/NotFound';
import { SendAndShareProvider } from 'lib/context/send-and-share/provider';

interface MatchParams {
  videoId: string;
}

export const SendAndShare = () => {
  const location = useLocation<{
    shouldNavigateToHome?: boolean;
    editScheduleId?: number;
  }>();
  const { editScheduleId, shouldNavigateToHome } = location.state || {};
  const { videoId } = useParams<MatchParams>();
  const history = useHistory();

  const goBackOnModalClose = () => {
    if (shouldNavigateToHome) {
      history.push('/home');
    } else {
      history.goBack();
    }
  };

  if (!videoId || isNaN(Number(videoId))) {
    return <NotFound />;
  }

  return (
    <SendAndShareProvider videoId={Number(videoId)}>
      <SendAndShareModal
        handleModalClose={goBackOnModalClose}
        editScheduleId={editScheduleId}
      />
    </SendAndShareProvider>
  );
};
